import { addEventListeners } from './utils/events'
import icons from './animated-icons'
import lottie from 'lottie-web'
import UI from './utils/UI'

UI({
  component: '.js-buttonIcon',
  animatedIcon: '.js-buttonIcon-animatedIcon'
}, ({ component, animatedIcon }) => {
  const iconAnimation = lottie.loadAnimation({
    renderer: 'svg',
    loop: true,
    autoplay: false,
    container: animatedIcon,
    animationData: icons[component.dataset.animatedIcon]
  })

  addEventListenersToElement(component)

  const hoverTriggerClass = component.getAttribute('data-hover-trigger')

  if (hoverTriggerClass) {
    const hoverTrigger = document.querySelector(`.${hoverTriggerClass}`)
    addEventListenersToElement(hoverTrigger)
  }

  function addEventListenersToElement (element) {
    addEventListeners(element, 'mouseenter focus', _ => iconAnimation.play(), false)
    addEventListeners(element, 'mouseleave blur', _ => iconAnimation.stop(), false)
  }
})
